import React from "react";
import Card from "@material-ui/core/Card";
import { useHistory } from "react-router-dom";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";
import { connect } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { redirect, HeaderBand, exportDocument } from "../../helpers";

const renderContent = ({
  hasHeaderBand,
  image,
  title,
  text,
  links,
  dark,
  history,
  linkThread,
}) => (
  <CardContent className="py-0 my-0 w-100 px-0 pb-1 m-sm-auto">
    {!!hasHeaderBand && <HeaderBand />}
    <div className="row m-sm-auto text-sm-center">
      <div
        className="col-md-4 text-sm-center"
        style={{ textAlign: window.innerWidth <= 768 ? "center" : "left" }}
      >
        <img
          src={image}
          className="img-fluid m-auto"
          alt={title || "imagen principal"}
        />
      </div>
      <div
        className={
          !!links && links.isButton
            ? "col-md-8 text-left my-4 m-sm-auto"
            : "col-md-8 text-left mt-3 mt-md-4 m-sm-auto"
        }
      >
        <Typography
          variant="h5"
          style={{
            color: dark ? "#eeeeee" : "#0f69b4",
            textAlign: window.innerWidth < 768 ? "center" : "left",
          }}
          gutterBottom
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          style={{ textAlign: window.innerWidth <= 768 ? "center" : "left" }}
          color="textPrimary"
          className={`${dark ? "text-white-50" : ""}`}
          gutterBottom
        >
          {text}
        </Typography>
        <div className="row pt-2">
          {!!links && (
            <div
              className={`col-md-4 ${
                !Array.isArray(links) ? "text-center" : "col-sm-12"
              }`}
            >
              {!!links && !Array.isArray(links) ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => exportDocument(links.redirect, history)}
                >
                  <Typography variant="button" noWrap>
                    {links.title}
                  </Typography>
                </Button>
              ) : (
                <List dense>
                  {links.map(
                    (link, i) =>
                      i < 5 && (
                        <ListItem
                          button
                          key={i}
                          className="m-2 rounded-lg text-center"
                          onClick={() => exportDocument(link.redirect, history)}
                          style={{
                            backgroundColor: dark ? "#5c5c5c" : "#ededed",
                          }}
                        >
                          <ListItemText
                            primary={link.title}
                            style={{ color: dark ? "#EEEEEE" : "#4A4A4A" }}
                          />
                        </ListItem>
                      )
                  )}
                </List>
              )}
            </div>
          )}
          {!!links && (
            <div
              className={`col-md-4 ${!Array.isArray(links) ? "" : "col-sm-12"}`}
            >
              <List dense>
                {Array.isArray(links) &&
                  links.map(
                    (link, i) =>
                      i >= 5 && (
                        <ListItem
                          button
                          key={i}
                          className="m-2 rounded-lg text-center"
                          onClick={() => exportDocument(link.redirect, history)}
                          style={{
                            backgroundColor: dark ? "#5c5c5c" : "#ededed",
                          }}
                        >
                          <ListItemText
                            primary={link.title}
                            style={{ color: dark ? "#EEEEEE" : "#4A4A4A" }}
                          />
                        </ListItem>
                      )
                  )}
              </List>
            </div>
          )}
          {!!linkThread && (
            <div className={`col-md-12`}>
              <List dense>
                {linkThread.map((link) => (
                  <ListItem
                    button
                    className="py-0 my-0"
                    onClick={() => window.open(link.redirect)}
                  >
                    <u>
                      <ListItemText
                        primary={link.title}
                        style={{ color: dark ? "#EEEEEE" : "#4A4A4A" }}
                      />
                    </u>
                  </ListItem>
                ))}
              </List>
            </div>
          )}
        </div>
      </div>
    </div>
  </CardContent>
);

const fullAction = (props) => (
  <CardActionArea
    onClick={() =>
      !Array.isArray(props.links)
        ? exportDocument(props.links.redirect, props.history)
        : null
    }
  >
    {renderContent(props)}
  </CardActionArea>
);

const CardMaterial = (props) => {
  const history = useHistory();
  return (
    <Card
      className={`mb-4 mt-2 px-0 mx-0`}
      style={{
        minWidth: 275,
      }}
    >
      {!Array.isArray(props.links) && !!!props.linkThread
        ? fullAction({ ...props, history })
        : renderContent({ ...props, history })}
    </Card>
  );
};

const mapStateToProps = (state) => ({
  dark: state.dark,
});

export default connect(mapStateToProps, {})(CardMaterial);
